import clsx from 'clsx';
import { Card, CardSubtitle, CardTitle } from '../../../../../shared/ui/card';
import { Checkbox } from '../../../../../shared/ui/checkbox/Checkbox';
import { CardList, CardListLayout, CardListRow } from '../shared';
import { useDisclosureChecked } from './lib/useDisclosureChecked';
import styles from './DisclosureCard.module.css';

export function DisclosureCard({
  className = '',
  disclosures = [],
  initialCheckedIds = [],
  onCheckedChange,
}) {
  const { checkedById, onToggle } = useDisclosureChecked({
    disclosures,
    initialCheckedIds,
    onCheckedChange,
  });

  return (
    <Card className={clsx(className)} aria-label="Disclosure">
      <CardTitle>Disclosure</CardTitle>
      <CardSubtitle>Required compliance disclosures</CardSubtitle>

      <CardListLayout>
        <CardList>
          {disclosures.map((item) => (
            <CardListRow key={item.id}>
              <div className={clsx(styles.checkboxWrap)}>
                <Checkbox
                  checked={Boolean(checkedById[item.id])}
                  onChange={(e) => onToggle(item.id, e.target.checked)}
                  disabled={item.is_required}
                  ariaLabel={`${item.name} disclosure`}
                  name={`disclosure-${item.id}`}
                  value={String(item.id)}
                />
              </div>
              <span className={clsx(styles.rowLabel)}>{item.name}</span>
            </CardListRow>
          ))}
        </CardList>
      </CardListLayout>
    </Card>
  );
}
